module.exports = __webpack_public_path__ + "img/logopromo.30f2072a.png";